module.exports = __webpack_public_path__ + "images/花筑村全景_02视频.jpg?v=0982e49e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_02视频.jpg
 ** module id = 87
 ** module chunks = 1 2
 **/